import React, { Component } from 'react';
import './../css/master.css';
import './../css/maintainCompany.css';
import Header from './../js/header.js';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from '../api/csAxios'

var lstCompany = [];
var queryString = require('querystring');

var httpURL = '';
class MaintainCompany extends Component {
	constructor(props){
		super(props);
		this.state={
			company:[],
			flg:true,
			loader:'none',
			opacity:1,
			width:'97%',
		}
	}

	async componentDidMount(){
	  this.setState({loader:'block', opacity:0.5});
	  await axiosInstance.get(httpURL+'/a/mst/pco/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					company:response.data.lstParentComp,
				})
				lstCompany = this.state.company;
				this.setCompanyTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					//setTimeout(function(){window.location.href = window.CSURL}.bind(this), 2000);
					return false;
				}
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);		
	  });
		this.handleResize();
	  window.addEventListener("load", this.handleResize);
	  window.addEventListener("resize", this.handleResize); 
	}
	
	handleResize=()=>{
		var width = ($('.tableLayout1').parent().width())-18;
		this.setState({width:width})
	}

	setCompanyTable =()=> {
		$('#companyTbody tr').remove();
		var table = document.getElementById('companyTable');
		var tbody = document.getElementById('companyTbody');
		var company = $('#filterCompany').val().trim().toUpperCase();
		
		for(var i=0; i<lstCompany.length; i++){
			var id 			= lstCompany[i].parentCompId;
			var name 		= lstCompany[i].parentComp;
			var externalQC 	= lstCompany[i].flgExtQC;
				externalQC	= externalQC == true || externalQC == 'Yes'  ? 'Yes' : 'No';
			var showMeters 	= lstCompany[i].showMeters;
				showMeters	= showMeters == true || showMeters == 'Yes'  ? 'Yes' : 'No';
			
			var row = document.createElement('tr');
			row.id = id;
			row.onclick =(e)=>{
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
				this.setCompanyForm($(e.target).closest('tr').attr('id'));
				this.setState({flg:false});
			}
			
			if(name.toUpperCase().indexOf(company) === -1)
				continue;
			
			this.addTD(row, id, 'no-display');
			this.addTD(row, name, '');
			this.addTD(row, externalQC, '');
			this.addTD(row, showMeters, '');
			
			tbody.append(row);
		}
		table.append(tbody);
	}

	addTD(row, val, classname){
		var cell = document.createElement('td');
		var text = document.createTextNode(val);
		cell.className = classname;
		cell.append(text);
		row.append(cell);
	}
	
	setCompanyForm =(id)=> {
		var companyData = this.getCompanyData(id);
		if(companyData !== -1){
			$('#inp_company').val(companyData.parentComp);
			$("#inp_QC").prop('checked', companyData.flgExtQC == "Yes" || companyData.flgExtQC == true ? true : false);
			$("#inp_showMeter").prop('checked', companyData.showMeters == "Yes" || companyData.showMeters == true ? true : false);
		}
	}
	
	getCompanyData(id){
		for(var i = 0; i < lstCompany.length; i++){
			if(id == lstCompany[i].parentCompId){
				return lstCompany[i];
			}
		}
		return -1;
	}

	maintainCompany=()=>{
		if(this.state.flg){
			this.addCompany();
		}else{
			this.editCompany();
		}
	}
	addCompany =()=> {
		var parentComp={};
		var company = $('#inp_company').val().toUpperCase();
		var flgExtQC = $('#inp_QC').prop('checked') == true ? 1 : 0;
		var showMeters = $('#inp_showMeter').prop('checked') == true ? 1 : 0;
		if(company === ''){
			toast.warning('Enter company name');
			document.getElementById('inp_company').focus();
			return false;
		}else{
			var x = window.confirm('This company will be created');
		}
		parentComp = {'parentCompId':0, 'parentComp':company, 'flgExtQC':flgExtQC, 'showMeters':showMeters};
		if(x){
			this.setState({loader:'block', opacity:0.5});
			axiosInstance.post(httpURL+'/a/mst/pco/save',
				queryString.stringify({'parentComp' : JSON.stringify(parentComp)}), {withCredentials:true}
		 	).then((response) =>{ 
				if(response.data.SvcStatus === "Success"){
					toast.success(response.data.SvcMsg);
					parentComp.flgExtQC = parentComp.flgExtQC == 0 ? 'No' : 'Yes';
					parentComp.showMeters = parentComp.showMeters == 0 ? 'No' : 'Yes';
					parentComp.parentCompId = response.data.parentCompId;
					lstCompany.push(parentComp);
					$('#inp_company').val('');
					$('#inp_QC').prop('checked', false);
					$('#inp_showMeter').prop('checked', false);
					this.setCompanyTable();
					this.setCompanyForm(response.data.parentCompId);
					this.highlightRow('companyTbody', response.data.parentCompId);
					this.setState({flg : false});
				}
				else{
					toast.error(response.data.SvcMsg);
				}
				this.setState({loader:'none', opacity:1});
		  	}).catch((error)=>{
					toast.error("Service failed "+error);
		  	});
		}
	}

	editCompany =()=> {
		var parentComp={};
		var companyId = $('#companyTbody tr.selected').find('td:eq(0)').text();
		var company = $('#inp_company').val().toUpperCase();
		var flgExtQC = $('#inp_QC').prop('checked') == true ? 1 : 0;
		var showMeters = $('#inp_showMeter').prop('checked') == true ? 1 : 0;
		
		if(companyId === ''){
			toast.warning('Please select row');
			return false;
		}
		if(company === ''){
			toast.warning('Enter company name');
			document.getElementById('inp_company').focus();
			return false;
		}else{
			var x = window.confirm('This company will be updated');
		}
		parentComp = {'parentCompId':companyId, 'parentComp':company, 'flgExtQC':flgExtQC, 'showMeters':showMeters};
		if(x){
			this.setState({loader:'block', opacity:0.5});
			axiosInstance.post(httpURL+'/a/mst/pco/save',
				queryString.stringify({'parentComp' : JSON.stringify(parentComp)}), {withCredentials:true}
		 	).then((response) =>{ 
				if(response.data.SvcStatus === "Success"){
					toast.success(response.data.SvcMsg);
					parentComp.flgExtQC = parentComp.flgExtQC == 0 ? 'No' : 'Yes';
					parentComp.showMeters = parentComp.showMeters == 0 ? 'No' : 'Yes';
					parentComp.parentCompId = companyId;
					var cmpyIdx = this.getCompanyIdex(companyId);
					lstCompany.splice(cmpyIdx, 1, parentComp);
					this.setCompanyTable();
					this.setCompanyForm(companyId);
					this.highlightRow('companyTbody', companyId);
				}
				else{
					toast.error(response.data.SvcMsg);
				}
				this.setState({loader:'none', opacity:1});
		  	}).catch((error)=>{
					toast.error("Service failed "+error);
		  	});
		}
	}
	
	getCompanyIdex=(id)=>{
		for(var i=0; i<lstCompany.length; i++){
			if(lstCompany[i].parentCompId == id){
				return i;
			}
		}
		return -1;
	}

	clear=(e)=>{
		$("#companyAddForm")[0].reset();
		this.setState({flg : true});
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var companyId = $(this).find('td:eq(0)').text();
			if(companyId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}
	
  render() {
	httpURL = window.httpURL;  
    return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-10 col-centered">
						<div className="col-sm-6 padding-remove">
							<table className='tableLayout1' style={{width:this.state.width}}>
								<thead>
									<tr>
									<th style={{width:60, display:'none'}}>Company Id</th>
										<th style={{width:100}}>
											<input type="text" className="form-control inp-search" placeholder="Company" onChange={this.setCompanyTable} id="filterCompany" />
										</th>
										<th style={{width:60}}>External QC</th>
										<th style={{width:60}}>Show Meters</th>
									</tr>
								</thead>
							</table>
							<div className="companyTableDiv">
							<table id="companyTable" className='tableLayout'>
								<colgroup>
									<col width='100' />
									<col width='60' />
									<col width='60' />
								</colgroup>
								<tbody id="companyTbody">
								</tbody>
							</table>
							</div>
						</div>
						<div className="col-sm-1 padding-remove">
							<span id="addCompany" title="Add Company"  onClick={this.clear} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-5">
							<form id="companyAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Company:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Company" id="inp_company"/>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-5">External QC:</label>
									<div className="checkbox">
										<div className="col-sm-7">
											<input type="checkbox" id="inp_QC"/>
										</div>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-5">Show Meters:</label>
									<div className="checkbox">
										<div className="col-sm-7">
											<input type="checkbox" id="inp_showMeter"/>
										</div>
									</div>
								</div>
								<div className="form-group" style={{marginTop:50}}>
									<div className="col-sm-12 text-center">
										<button type="button" onClick={this.maintainCompany} className="btn btn-warning">Save</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
  }
}

export default MaintainCompany;
